// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__x0Izg","search__content":"Search_search__content__q37mF","recipe":"Search_recipe__iudcy","more":"Search_more__J5tNO","not_found":"Search_not_found__lF9-F"};